import { render } from "./SettingsTabComorbidities.vue?vue&type=template&id=6d12f15c&scoped=true"
import script from "./SettingsTabComorbidities.vue?vue&type=script&lang=js"
export * from "./SettingsTabComorbidities.vue?vue&type=script&lang=js"

import "./SettingsTabComorbidities.vue?vue&type=style&index=0&id=6d12f15c&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d12f15c"]])

export default __exports__